var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90,46.667V33.334c0-9.204-17.91-16.667-40-16.667c-22.091,0-39.999,7.463-39.999,16.667v13.333 c0,4.068,3.511,7.796,9.328,10.689L10,83.333h7.083l8.442-23.502c5.942,1.92,13.205,3.157,21.141,3.431v13.405h6.667V63.262 c7.937-0.273,15.199-1.511,21.14-3.431l8.444,23.502H90l-9.329-25.977C86.487,54.463,90,50.735,90,46.667z M83.333,46.667 c0,2.571-11.461,10-33.333,10c-21.87,0-33.332-7.429-33.332-10v-4.128C23.833,47.035,36.081,50,50,50 c13.919,0,26.169-2.967,33.333-7.461V46.667z M50,43.334c-21.87,0-33.332-7.431-33.332-10c0-2.57,11.461-10,33.332-10 c21.872,0,33.333,7.43,33.333,10C83.333,35.903,71.872,43.334,50,43.334z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.ebe47470961f5ad7cd7b9522ca0de023.svg";
export { ForwardRef as ReactComponent };